<template>
    <div :class="[companyClass , canScroll]">
        <div class="page-systemCategoriess flex column  mb-20">
            <div class="page-header">
				<h1 class="pageTitle">Add system category</h1>
				<h4>new system category </h4>
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
					<el-breadcrumb-item>settings</el-breadcrumb-item>
					<el-breadcrumb-item>system categorys</el-breadcrumb-item>
					<el-breadcrumb-item>add ex-rates</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

            <div class="mt-0 w-100">
				<div style="float: right;">
                    <el-button v-show="userPermissionsFilter.addsystemcategories"
                        type="primary" icon="el-icon-plus"
						@click="handleNew"></el-button>

					<el-button v-show="userPermissionsFilter.viewsystemcategories" type="warning" icon="el-icon-tickets"
						@click="handleExit"></el-button>

                    <el-button type="primary"
                     @click="validateAndSave" v-show="canSaveChanges" :disabled="saveChanges">
                     <i class="mdi mdi-content-save"></i></el-button>
				</div>
			</div>

            <div class="mt-10">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <span>Country</span><span :class="required"> *</span>
                        <el-select v-model="systemCategory.countryId" filterable clearable placeholder="Country" class="mb-10"
                        style="width:100%" name="countryid" v-validate="'required'" data-vv-as="countryid">
                        <el-option v-for="country in countries" :key="country.id" :label="country.name" :value="country.id"></el-option>
                        </el-select>
                        <transition name="fade">
                            <span class="danger-text">{{ errors.first('countryid') }}</span>
                        </transition>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <span>Customer Type</span><span :class="required"> *</span>
                        <el-select v-model="systemCategory.customerType" filterable clearable placeholder="Select Customer Type" class="mb-10" style="width:100%" name="customerType" v-validate="'required'" data-vv-as="customerType">
                            <el-option label="Individual" value="0"></el-option>
                            <el-option label="Company" value="1"></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <span>Category Context</span><span :class="required"> *</span>
                        <el-select v-model="systemCategory.systemCategoryContext" filterable clearable placeholder="Category Context" class="mb-10"
                        style="width:100%" name="categorycontext" v-validate="'required'" data-vv-as="category context"
                        :disabled="readOnlyMode" @change="categoryContextChanged">
                            <el-option
                            v-for="contexts in systemCategoryContexts"
                            :key="contexts"
                            :label="contexts"
                            :value="contexts">
                            </el-option>
                        </el-select>
                        <transition name="fade">
                            <span class="danger-text">{{ errors.first('categorycontext') }}</span>
                        </transition>
                    </el-col>
                    <el-col :span="12" v-show="showType">
                        <span>Sub-Category</span><span :class="required"> *</span>
                        <el-select v-model="systemCategory.systemCategoryType" filterable clearable placeholder="Category Type" class="mb-10"
                        style="width:100%"
                        :disabled="readOnlyMode" @change="propertyChanged"
                        >
                            <el-option
                            v-for="ctypes in categoryTypes"
                            :key="ctypes"
                            :label="ctypes"
                            :value="ctypes">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row :gutter="20" class="mt-10">
                    <el-col :span="12">
                        <span>System Category Name</span><span :class="required"> *</span>
                        <el-input placeholder="system category" v-model="systemCategory.name"
                                    name="name" v-validate="'required'" data-vv-as="system category name"
                                    :readonly="readOnlyMode" @blur="propertyChanged"></el-input>
                        <transition name="fade">
                            <span class="danger-text">{{ errors.first('name') }}</span>
                        </transition>
                    </el-col>
                </el-row>
                <el-row :gutter="20" class="mt-10">
                    <el-col :span="12">
                        <span>System Category Description</span><span :class="required"> *</span>
                        <el-input placeholder="system category description" type="textarea" :rows="3" v-model="systemCategory.description"
                                    :readonly="readOnlyMode" @blur="propertyChanged"></el-input>
                    </el-col>
                </el-row>
                <div class="mt-10">
                    <el-button type="primary" v-show="!readOnlyMode" @click="validateAndSave"><i></i> Save System Categories</el-button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/'
import { bus } from '@/main'
import { Validator } from 'vee-validate'

export default {
    name: 'AddSystemCategories',
    data() {
        return {
            systemCategoryContexts: [ 'Transactions', 'Source of Funds','Purpose of Remittance'],
            systemCategory: {
                id: 0,
                name: '',
                countryId: 0,
                customerType: '',
                description: '',
                systemCategoryContext: '',
                systemCategoryType: ''
            },
            categoryTypes: []
        }
    },
    computed: {
        canSaveChanges(){
            return this.saveChanges && !this.readOnlyMode;
        },
        readOnlyMode() {
            return !this.userPermissionsFilter.addsystemcategories &&
            !this.userPermissionsFilter.editsystemcategories;
        },
        showType() {
            return this.categoryTypes.length > 0;
        }
    },
    methods: {
        createNew() {
             router.push('/addsystemCategories');
             this.clearState();
        },
        viewCategories() {
            router.push('/systemCategories');
        },
        clearState() {
             this.systemCategory = {
                id: 0,
                name: '',
                description: '',
                systemCategoryContext: '',
                systemCategoryType: ''
            };


            this.$validator.reset();
        },
        categoryContextChanged(e) {
            this.categoryTypes = [];
            this.propertyChanged();
            this.getCategoryTypes(e)
            .then(result=> {
                this.categoryTypes = result;
            });
        },
        submitSystemCategories() {
            this.saveSystemCategory(this.systemCategory)
            .then(result=> {
                if(result && result.id > 0)
                {
                    this.successMessage('System category was added successfully.');
                    this.clearState();
                    this.entitySaved();
                }
                else
                {
                    this.errorMessage('Failed to add system category.');
                }
            });
        },
        validateAndSave() {
            let self = this;
            this.$validator.validateAll()
            .then(result=> {
                if(result){
                    this.submitSystemCategories();
                }
            })
            .catch(err=> console.log(err));
        },
        setCurrent() {
			var id = router.currentRoute.params.id;

			this.pageTitle = 'Add System Category';
			this.pageSubtitle = 'create system category';

			if(id){
				this.canDelete = true;
				this.pageTitle = 'system category info';
				this.findSystemCategory(id)
				.then(result=> {
                    if(result){
                        this.systemCategory = result;
				        this.pageSubtitle = 'view system category info';
                    }
			});
			}
		}
    },
    created() {
        this.newEvent = 'createNew';
        this.saveEvent = 'validateAndSave';
        this.exitEvent = 'viewCategories';
        this.$on(this.saveEvent, this.validateAndSave);
        this.$on(this.newEvent, this.createNew);
        this.$on(this.exitEvent, this.viewCategories);
        this.getCountries();
        this.setCurrent();
    },
    mixins: [PermissionsMixins]
}
</script>


<style lang="scss" scoped>
@import '../../assets/scss/_variables';
</style>
